__turbopack_context__.v({
  "dark": "Footer-module-scss-module__A5O-ua__dark",
  "inner-circle": "Footer-module-scss-module__A5O-ua__inner-circle",
  "inner-circle-container": "Footer-module-scss-module__A5O-ua__inner-circle-container",
  "inner-circle-outline": "Footer-module-scss-module__A5O-ua__inner-circle-outline",
  "social-links-container": "Footer-module-scss-module__A5O-ua__social-links-container",
});
